import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'
import { SpinnerContext } from '../../../context/spinnerContext'
import { addNotesSchema } from '../../../util/validationSchema'
import { addSupervisorNote, editSupervisorNote } from '../../../redux/slices/supervisorSlice'
import { errorToast, successToast } from '../../../util/Toast/toast'

const AddNotes = ({ toggleNotesModal, cleaner_id, setIsRefresh, editId }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const { noteInfo } = useSelector(({ notes }) => notes)
  const defaultValues = editId ? { cleaners_id: cleaner_id, description: noteInfo?.description } : { cleaners_id: cleaner_id }

  const { handleSubmit, control, trigger } = useForm({
    resolver: yupResolver(addNotesSchema),
    defaultValues: defaultValues
  })

  const onSubmit = (data) => {
    changeLoader(true)
    if (editId) {
      const payload = {
        id: editId,
        data: {
          description: data?.description
        }
      }
      dispatch(editSupervisorNote(payload))
        .then(({ payload }) => {
          if (payload?.status === 200) {
            successToast(payload?.data?.status_message || 'Success!')
            changeLoader(false)
            toggleNotesModal()
            setIsRefresh(true)
          } else {
            errorToast(payload?.data?.status_message || 'Somthing went wrong!')
            changeLoader(false)
          }
        })
        .catch((err) => {
          console.log('err :>> ', err)
          changeLoader(false)
        })
    } else {
      dispatch(addSupervisorNote(data))
        .then(({ payload }) => {
          if (payload?.status === 200) {
            successToast(payload?.data?.status_message || 'Success!')
            changeLoader(false)
            toggleNotesModal()
            setIsRefresh(true)
          } else {
            errorToast(payload?.data?.status_message || 'Somthing went wrong!')
            changeLoader(false)
          }
        })
        .catch((err) => {
          console.log('err :>> ', err)
          changeLoader(false)
        })
    }
  }

  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <div className="form-group">
              <label>
                Description<span className="text-danger"></span>
              </label>
              <Controller
                name={`description`}
                control={control}
                render={({ field: { value, onChange }, fieldState }) => (
                  <>
                    <textarea
                      className="form-control"
                      type="text"
                      value={value || ''}
                      onChange={(val) => {
                        onChange(val)
                        trigger(`description`)
                      }}
                      placeholder="Enter Description"
                      autoComplete="false"
                      rows="5"
                    ></textarea>
                    <small>{fieldState?.error?.message}</small>
                  </>
                )}
              />
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => toggleNotesModal()}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary common-field-btn w-100">
              {editId ? `Update` : `Save`}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default AddNotes
